import { useEffect } from 'react';

import { bindAppResume } from '@/shared/lib/telegram';

import { refreshAppData } from './refresh-app-data';

/** Подписывает обновление данных на возврат игрока в мини-апп. */
export function useRefreshOnResume(): void {
  useEffect(
    () =>
      bindAppResume(() => {
        void refreshAppData();
      }),
    [],
  );
}
